module.exports = __webpack_public_path__ + "static/media/slim-cereja.81b2f06b.webp";